var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cookiePolicy)?_c(_vm.modules.CookiePolicy,_vm._b({tag:"component"},'component',_vm.cookiePolicy,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }